export const getFtdReportColumns = () => [
  {
    title: "Client",
    dataIndex: "clientName",
    key: "clientName",
    render: (value) => value || "--",
  },
  {
    title: "Country",
    dataIndex: "country",
    key: "country",
    render: (value) => value || "--",
  },
  {
    title: "Account Mgr.",
    dataIndex: "accountManager",
    key: "accountManager",
    render: (value) => value || "--",
  },
  {
    title: "Team",
    dataIndex: "team",
    key: "team",
    render: (value) => value || "--",
  },
  {
    title: "Office",
    dataIndex: "office",
    key: "office",
    render: (value) => value || "--",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (value) => value || "--",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (value) => (value ? String(value).slice(0, 10) : "--"),
  },
  {
    title: "Method",
    dataIndex: "method",
    key: "method",
    render: (value) => value || "--",
  },
  {
    title: "Account",
    dataIndex: "account",
    key: "account",
    render: (value) => value || "--",
  },
  {
    title: "Source",
    dataIndex: "source",
    key: "source",
    render: (value) => value || "--",
  },
  {
    title: "Sales Owner",
    dataIndex: "salesOwner",
    key: "salesOwner",
    render: (value) => value || "--",
  },
];
